/* src/app/shared/components/lead-details-address/lead-details-address.component.css */
input:read-only {
  cursor: default;
  background-color: light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3));
  color: light-dark(rgb(84, 84, 84), rgb(170, 170, 170));
}
/*# sourceMappingURL=lead-details-address.component-EBIDIZ6A.css.map */
